import { TextField } from "@mui/material";
import { useState } from "react";
import { ReactComponent as Eye } from "../../../../../assets/icons/eye.svg";
import { ReactComponent as EyeSlash } from "../../../../../assets/icons/eye-slash.svg";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import az from "date-fns/locale/az";
import {
  getPhoneDisplayValue,
  createPhoneInputHandlers,
} from "../../../../utils/phoneFormat";

export default function InputField({
  formik,
  modalData,
  inputName,
  updateModalState,
}) {
  const [shrink, setShrink] = useState(false);
  // const [viewPass, setViewPass] = useState(true);
  registerLocale("az", az);

  const statusNotes = [
    modalData?.firstCallAddInfo,
    modalData?.wsMessageAddInfo,
    modalData?.warmCallAddInfo,
    modalData?.coldCallAddInfo,
    modalData?.iceCallAddInfo,
    modalData?.appointedConsultationAddInfo,
    modalData?.salesAddInfo,
    modalData?.cancelledAddInfo,
  ]
    .filter(Boolean)
    .join(" | ");

  const displayValue = statusNotes
    ? `${statusNotes}${modalData?.addInfo ? " | " + modalData.addInfo : ""}`
    : modalData?.addInfo || "";

  // console.log(displayValue, "combine");

  // Telefon nömrəsi üçün handler-lər (global util-dən)
  const phoneHandlers = createPhoneInputHandlers((val) =>
    updateModalState("studentPhone", val),
  );

  const renderDatePicker = (dateName, label) => (
    <div className="render-datepicker">
      <label>
        {label}{" "}
        {(modalData.status === "sold" || dateName === "contactDate") &&
          dateName !== "birthday" && <span style={{ color: "red" }}>*</span>}
      </label>

      <DatePicker
        selected={modalData[dateName] ? new Date(modalData[dateName]) : null}
        onChange={(date) => updateModalState(dateName, date)}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        dateFormat="dd/MM/yyyy"
        placeholderText="dd/mm/yyyy"
        locale="az"
        disabled={dateName === "createdAt"}
      />
    </div>
  );

  const inputData = [
    {
      inputName: "studentName",
      label: "Tələbə",
      type: "text",
      inputValue: modalData?.studentName || "",
      required: true,
      margintBottom: 0,
    },
    {
      inputName: "fin",
      label: "Fin",
      type: "text",
      inputValue: modalData?.fin || "",
      marginTop: "24px",
    },
    {
      inputName: "seria",
      label: "Seriya",
      type: "text",
      inputValue: modalData?.seria || "",
      marginTop: "24px",
    },
    {
      inputName: "addInfo",
      label: "Statusa əlavə qeyd",
      type: "text",
      inputValue: displayValue || "",
      marginTop: "24px",
    },

    // {
    //   inputName: "firstCallAddInfo",
    //   label: "Statusa əlavə qeyd",
    //   type: "text",
    //   inputValue: modalData?.firstCallAddInfo || "",
    //   marginTop: "24px",
    // },
    // {
    //   inputName: "wsMessageAddInfo",
    //   label: "Statusa əlavə qeyd",
    //   type: "text",
    //   inputValue: modalData?.wsMessageAddInfo || "",
    //   marginTop: "24px",
    // },
    // {
    //   inputName: "warmCallAddInfo",
    //   label: "Statusa əlavə qeyd",
    //   type: "text",
    //   inputValue: modalData?.warmCallAddInfo || "",
    //   marginTop: "24px",
    // },
    // {
    //   inputName: "coldCallAddInfo",
    //   label: "Statusa əlavə qeyd",
    //   type: "text",
    //   inputValue: modalData?.coldCallAddInfo || "",
    //   marginTop: "24px",
    // },
    // {
    //   inputName: "iceCallAddInfo",
    //   label: "Statusa əlavə qeyd",
    //   type: "text",
    //   inputValue: modalData?.iceCallAddInfo || "",
    //   marginTop: "24px",
    // },
    // {
    //   inputName: "appointedConsultationAddInfo",
    //   label: "Statusa əlavə qeyd",
    //   type: "text",
    //   inputValue: modalData?.appointedConsultationAddInfo || "",
    //   marginTop: "24px",
    // },
    // {
    //   inputName: "salesAddInfo",
    //   label: "Statusa əlavə qeyd",
    //   type: "text",
    //   inputValue: modalData?.salesAddInfo || "",
    //   marginTop: "24px",
    // },
    // {
    //   inputName: "cancelledAddInfo",
    //   label: "Statusa əlavə qeyd",
    //   type: "text",
    //   inputValue: modalData?.cancelledAddInfo || "",
    //   marginTop: "24px",
    // },
    {
      inputName: "barterService",
      label: "Barter xidməti",
      type: "text",
      inputValue: modalData?.barterService || "",
      marginTop: "24px",
    },
    {
      inputName: "constDate",
      label: "Konsultasiya tarixi",
      type: "date",
      className: "birthday-input",
    },
    {
      inputName: "birthday",
      label: "Doğum tarixi",
      type: "date",
      className: "birthday-input",
    },
    {
      inputName: "constTime",
      label: "Konsultasiya saatı",
      type: "time",
      inputValue: modalData?.constTime || "",
    },
    {
      inputName: "contactDate",
      label: "İlkin zəng ediləcək",
      type: "date",
      className: "birthday-input",
      required: true,
    },
    {
      inputName: "createdAt",
      label: "Leadin yaranma tarixi",
      type: "date",
      className: "birthday-input",
      required: false,
    },
    {
      inputName: "studentPhone",
      label: "Mobil nömrə",
      type: "tel",
      inputValue: getPhoneDisplayValue(modalData?.studentPhone || ""),
      required: true,
    },

    {
      inputName: "salesDate",
      label: "satış tarixi",
      type: "date",
      className: "birthday-input",
      marginTop: "24px",
    },
  ];

  return (
    <div
      className={
        inputData.find((item) => item.inputName === inputName)?.className || ""
      }
    >
      {inputName === "constDate" ||
      inputName === "contactDate" ||
      inputName === "createdAt" ||
      inputName === "salesDate" ||
      inputName === "birthday" ? (
        renderDatePicker(
          inputName,
          inputName === "contactDate"
            ? "İlkin zəng ediləcək tarix"
            : inputName === "salesDate"
              ? "Satış tarixi"
              : inputName === "birthday"
                ? "Doğum tarixi"
                : inputName === "createdAt"
                  ? "Leadin yaranma tarixi"
                  : "Konsultasiya tarixi",
        )
      ) : (
        <TextField
          multiline={inputName === "addInfo"}
          minRows={inputName === "addInfo" ? 3 : undefined}
          maxRows={inputName === "addInfo" ? 10 : undefined}
          sx={{
            "& input": {
              fontSize: "12px",
              paddingRight: inputData.find(
                (item) => item.inputName === inputName,
              )?.paddingRight,
            },
            "& textarea": {
              fontSize: "12px",
            },
            marginTop: inputData.find((item) => item.inputName === inputName)
              ?.marginTop,
            marginBottom: inputData.find((item) => item.inputName === inputName)
              ?.marginBottom,
            "& .MuiInputLabel-root.Mui-required:after": {
              content: '" *"',
              color: "red",
              fontSize: "12px",
            },
          }}
          InputLabelProps={{
            shrink:
              inputData.find((item) => item.inputName === inputName)?.type ===
                "date" ||
              inputData.find((item) => item.inputName === inputName)?.type ===
                "time"
                ? true
                : inputData.find((item) => item.inputName === inputName)
                      ?.inputValue
                  ? true
                  : shrink,
            style: {
              fontSize: "12px",
              color: "#3F3F3F",
              marginBottom: inputData.find(
                (item) => item.inputName === inputName,
              ).marginBottom,
            },
          }}
          fullWidth
          id={inputName}
          name={inputName}
          type={inputData.find((item) => item.inputName === inputName).type}
          label={inputData.find((item) => item.inputName === inputName).label}
          value={
            inputData.find((item) => item.inputName === inputName)?.inputValue
          }
          onWheel={(e) => e.target.blur()}
          // onChange={(e) => updateModalState(inputName, e.target.value)}
          onChange={(e) => {
            if (inputName === "studentPhone") {
              phoneHandlers.onChange(e);
            } else if (inputName === "addInfo") {
              let value = e.target.value;

              if (statusNotes && value.startsWith(statusNotes)) {
                value = value.slice(statusNotes.length);

                if (value.startsWith(" | ")) {
                  value = value.slice(3);
                }
              }

              updateModalState("addInfo", value);
            } else {
              updateModalState(inputName, e.target.value);
            }
          }}
          onKeyDown={
            inputName === "studentPhone" ? phoneHandlers.onKeyDown : undefined
          }
          onBlur={(e) => {
            formik.setFieldTouched(inputName, true);
            setShrink(!!e.target.value);
          }}
          onFocus={() => setShrink(true)}
          required={
            inputData.find((item) => item.inputName === inputName)?.required
          }
          disabled={
            inputName === "firstCallAddInfo" ||
            inputName === "coldCallAddInfo" ||
            inputName === "wsMessageAddInfo" ||
            inputName === "warmCallAddInfo" ||
            inputName === "iceCallAddInfo" ||
            inputName === "appointedConsultationAddInfo" ||
            inputName === "salesAddInfo" ||
            inputName === "cancelledAddInfo"
          }
        />
      )}

      {formik.errors[inputName] && formik.touched[inputName] && (
        <small className="validation-err-message">
          {formik.errors[inputName]}
        </small>
      )}
    </div>
  );
}
